module.exports = __webpack_public_path__ + "static/media/GalleryImage04.4309727d.jpg";